module.exports = __webpack_public_path__ + "static/media/SanBernardo.773d601d.png";